import { render, staticRenderFns } from "./digital-dashboard.vue?vue&type=template&id=0d75246e&scoped=true"
import script from "./digital-dashboard.vue?vue&type=script&lang=js"
export * from "./digital-dashboard.vue?vue&type=script&lang=js"
import style0 from "./digital-dashboard.vue?vue&type=style&index=0&id=0d75246e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d75246e",
  null
  
)

export default component.exports